import {Component, OnDestroy, OnInit} from '@angular/core';
import {AvailablePluginsComponent} from "../plannerComponents/available-plugins/available-plugins.component";
import {InitialPlanComponent} from "../plannerComponents/initial-plan/initial-plan.component";
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective, NgbAccordionHeader, NgbAccordionItem
} from "@ng-bootstrap/ng-bootstrap";
import {PluginActionComponent} from "../plannerComponents/plugin-action/plugin-action.component";
import {
  PluginActionResponseComponent
} from "../plannerComponents/plugin-action-response/plugin-action-response.component";
import {RevisedPlanComponent} from "../plannerComponents/revised-plan/revised-plan.component";
import {TaskDefinitionComponent} from "../plannerComponents/task-definition/task-definition.component";
import {TaskOutcomeComponent} from "../plannerComponents/task-outcome/task-outcome.component";
import {TranslateModule} from "@ngx-translate/core";
import {UserIntentComponent} from "../plannerComponents/user-intent/user-intent.component";
import {RagUserIntentComponent} from "../ragComponents/rag-user-intent/rag-user-intent.component";
import {RetrievalComponent} from "../ragComponents/retrieval/retrieval.component";
import {RagFinalAnswerComponent} from "../ragComponents/rag-final-answer/rag-final-answer.component";
import {AnswerGenerationComponent} from "../ragComponents/answer-generation/answer-generation.component";
import {ChatRepository} from "../../repositories/chat.repository";
import {ActivatedRoute, Router} from "@angular/router";
import {RagRepository} from "../../repositories/rag.repository";
import {STEP_STATUS, STEP_TYPE} from "../../models/enums";
import {JsonPipe, NgClass, NgIf} from "@angular/common";
import {last, lastValueFrom} from "rxjs";
import {LoaderService} from "../../services/loader.service";

@Component({
  selector: 'app-rag',
  standalone: true,
  imports: [
    AvailablePluginsComponent,
    InitialPlanComponent,
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionHeader,
    NgbAccordionItem,
    PluginActionComponent,
    PluginActionResponseComponent,
    RevisedPlanComponent,
    TaskDefinitionComponent,
    TaskOutcomeComponent,
    TranslateModule,
    UserIntentComponent,
    RagUserIntentComponent,
    RetrievalComponent,
    RagFinalAnswerComponent,
    AnswerGenerationComponent,
    NgClass,
    JsonPipe,
    NgIf
  ],
  templateUrl: './rag.component.html',
  styleUrl: './rag.component.css'
})
export class RagComponent implements OnInit,OnDestroy {
  toolingId: string | null = "";
  toolingSteps!: any[];
  tooling: any;
  isLoading: boolean = false;
  private reloadTimeout: any;
  constructor(private ragRepository: RagRepository, private router: Router, private route: ActivatedRoute, public loaderService: LoaderService) {}
  async ngOnInit(): Promise<void> {
    this.isLoading= true;
    this.route.paramMap.subscribe(params => {
      this.toolingId = params.get('ragId');
      if (this.toolingId) {
        this.loadTooling(this.toolingId);
      }
    });
  }

  async loadTooling(id: string): Promise<void> {
    this.isLoading= true;
    this.ragRepository.getRag(id).subscribe(
      async (tooling: any) => {
        this.tooling=tooling;
        const promises = tooling.steps.map(async (stepID: string, index: number) => {
          const toolingStep = await lastValueFrom(this.ragRepository.getToolingStep(id, stepID)) ;
          tooling.steps[index] = toolingStep;
        });
        await Promise.all(promises);
        this.toolingSteps= tooling.steps;
        if (this.toolingSteps[this.toolingSteps.length-1].stepStatus ==STEP_STATUS.USER_FINALIZED || this.toolingSteps[this.toolingSteps.length-1].stepStatus==STEP_STATUS.AUTO_FINALIZED &&  this.toolingSteps[this.toolingSteps.length-1].stepType!=STEP_TYPE.FINAL_ANSWER){
       this.reloadTimeout= setTimeout(async () => {
            await this.loadTooling(id);
          }, 2000);
        }
        else{
          this.isLoading=false;
        }

      }
    );
  }
  ngOnDestroy(): void {
    if (this.reloadTimeout) {
      clearTimeout(this.reloadTimeout);
    }
  }
  protected readonly STEP_TYPE = STEP_TYPE;
  protected readonly STEP_STATUS = STEP_STATUS;
}
